<sync-error *ngIf="errcode.code != 2015" [errcode]="errcode"></sync-error>
<div *ngIf="errcode.code == 2015" class="row">
    <div class="col-xs-12 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
        <br /><br/>
        <div class="panel panel-default" *ngIf="errcode.code == 2015">
            <div class="panel-heading">
                <h3 class="panel-title"><i class="fas fa-lock"></i> Enter Key</h3>
            </div>
            <div class="panel-body">
                <p>This link is missing the key.  Please enter the key to
                    access this link.  If you do not know what this is,
                    please ask the link owner to provide it.
                </p>
                <div class="form-group">
                    <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="key"
                    />
                </div>
            </div>
            <div class="panel-footer text-right">
                <button class="btn btn-primary" (click)="setKey()">
                    <i class="fa fa-spin fa-spinner" *ngIf="spinner"></i>
                    Submit
                </button>
            </div>
        </div>
    </div>
    <div class="col-sm-2 col-md-3"></div>
</div>  <!-- end row -->
